import styled from 'styled-components';
import { space } from 'styled-system';
import getThemeValue from '../../util/getThemeValue';
import { SvgProps } from './Svg.types';

const Svg = styled.svg<SvgProps>`
  fill: ${({ theme, color, fill }) =>
    fill || getThemeValue(`colors.${color}`, color)(theme)};
  flex-shrink: 0;
  ${space}
`;

Svg.defaultProps = {
  color: 'text',
  width: '20px',
  xmlns: 'http://www.w3.org/2000/svg',
  spin: false
};

export default Svg;
